/* eslint-disable max-len */
/* eslint-disable import/extensions */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import { useHistory, NavLink } from 'react-router-dom';
import {
  Box, Grid, Paper, Typography, CircularProgress,
  Link,
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
import AddIcon from '@mui/icons-material/Add';
import ButtonTemplate from '../../components/Button/Button';
import Modal from '../../components/Modal';
import LoadingFull from '../../components/LoadingFull';
import { colors } from '../../services/colors';
import Historico from '../Historico';
import { getNotificacoes } from '../../services/solicitacaoAPI';
import { LinksStore } from '../../services/zustandProvider';
import './styles.css';

export default function Dashboard():JSX.Element {
  const history = useHistory();
  const [openHistorico, setOpenHistorico] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notificacao, setNotificacao] = useState(false);
  const [notificacoes, setNoticacoes] = useState<string[]>([]);
  const { LinkSite, LinkPoliticas } = LinksStore();
  async function logout() {
    localStorage.removeItem('ptt:User');
    history.push('/Login');
  }

  useEffect(() => {
    async function get() {
      setLoading(true);
      const notificaRetorno = await getNotificacoes();
      if (notificaRetorno?.dados) {
        if (notificaRetorno?.dados.length > 0) {
          setNotificacao(true);
          setNoticacoes(notificaRetorno?.dados);
        }
      }
      setLoading(false);
    } get();
  }, []);

  return (
    <>
      <Box sx={{
        marginTop: 'auto',
        display: 'flex',
        width: '97%',
        flexDirection: 'column',
        height: 'calc(99% - 120px)',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
      }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: 'flex', padding: '30px',
            }}
          >
            <NavLink
              to="/NovaSolicitacao"
              style={{
                width: '100%', marginLeft: 'auto', marginRight: 'auto', display: 'flex',
              }}
            >
              <ButtonTemplate
                cor="cyan"
                tonalidade={800}
                sx={{
                  width: '60%', height: { xs: '100px', sm: '150px' }, marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', position: 'relative',
                }}
              >
                <Typography sx={{ fontWeight: 'bold', fontSize: '20px' }}>Nova Solicitação</Typography>
                {' '}
                <AddIcon fontSize="large" sx={{ position: 'absolute', top: '3%', right: '3%' }} />
              </ButtonTemplate>
            </NavLink>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ padding: '30px' }}>
            <Box
              style={{
                width: '100%', marginLeft: 'auto', marginRight: 'auto', display: 'flex',
              }}
            >
              <ButtonTemplate
                cor="cyan"
                disabled={loading}
                tonalidade={800}
                onClick={() => history.push({
                  pathname: '/Historico',
                  state: { // location state
                    notifica: notificacoes,
                  },
                })}
                sx={{
                  width: '60%', height: { xs: '100px', sm: '150px' }, marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', position: 'relative',
                }}
              >
                <Typography sx={{ fontWeight: 'bold', fontSize: '20px' }}>Histórico de soicitações</Typography>
                {' '}
                <HistoryIcon fontSize="large" sx={{ position: 'absolute', top: '3%', right: '3%' }} />
                {
                    !loading ? (
                      notificacao && (
                      <Typography
                        align="right"
                        sx={{
                          position: 'absolute', bottom: '-50px', right: '3%', color: 'black', paddingRight: '30px',
                        }}
                      >
                        Há novas mensagens para você!
                        <MarkEmailUnreadOutlinedIcon sx={{
                          position: 'absolute', top: '0px', marginLeft: '10px', color: colors.themePrimary,
                        }}
                        />
                      </Typography>
                      )) : (
                        <CircularProgress
                          size={20}
                          sx={{
                            color: 'white', position: 'relative', left: '3%',
                          }}
                        />
                    )
                }
              </ButtonTemplate>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ position: 'absolute', bottom: '3%', right: { xs: '2%', sm: '12%' } }}>
        <Typography sx={{ fontSize: '15px' }} align="right">
          Para maiores informações sobre LGPD, consulte
          {' '}
          <Link href={LinkSite} target="_blank">nossa página</Link>
          {' '}
          e
          {' '}
          <Link href={LinkPoliticas} target="_blank">nossa Política de Privacidade</Link>
        </Typography>
      </Box>
      {/* <Modal
        fullWidth
        maxWidth="lg"
        title="Historico"
        iconTitle={(
          <HistoryIcon sx={{ color: colors.themePrimary, fontSize: '30px', marginLeft: '10px' }} />
)}
        hide={() => setOpenHistorico(false)}
        open={openHistorico}
      >
        <Historico />
      </Modal> */}
    </>
  );
}
